import { createContext } from "react";

// Create context for NavSearch and NavBreadcrumb components (Provider) and RecipeResults component (Consumer)
const SearchContext = createContext("");

export default SearchContext;